import {
  Component,
  computed,
  effect,
  inject,
  input,
  signal,
} from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { TransfloTopNavComponent } from '@transflo/transflo-design-system';
import { environment } from '../../../../environments/environment';
import { AuthStateService } from '../../services/auth-state/auth-state.service';
import { LaunchApplicationService } from '../../services/launch-application/launch-application.service';
import { PagesNavBarComponent } from './pages-nav-bar/pages-nav-bar.component';

@Component({
  selector: 'fw-nav-bar',
  imports: [RouterOutlet, PagesNavBarComponent, TransfloTopNavComponent],
  templateUrl: './nav-bar.component.html',
  styleUrl: './nav-bar.component.scss',
})
export class NavBarComponent {
  // services
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly authStateService = inject(AuthStateService);
  private readonly launchApplicationService = inject(LaunchApplicationService);

  readonly localAccess = input<string>();
  readonly localRefresh = input<string>();

  protected readonly localTokens = computed(() => {
    const access = this.localAccess();
    const refresh = this.localRefresh();
    if (access === undefined || refresh === undefined) return undefined;
    return { accessToken: access, refreshToken: refresh };
  });

  // parameters
  protected portalTokenNew = signal('');

  constructor() {
    effect(() => {
      const token =
        this.portalTokenNew() ?? this.authStateService.getRawToken(); // ← FIXED

      if (!token) return;

      this.persistAuthenticationToken(token);
      this.launchApplicationService.fetchLaunchApplication();

      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { localAccess: null, localRefresh: null },
        queryParamsHandling: 'merge',
        onSameUrlNavigation: 'ignore',
      });
    });
  }

  protected readonly isLocal = signal(
    window.location.hostname.includes('localhost')
  );

  private readonly persistAuthenticationToken = (token: string): void => {
    if (token === undefined) {
      // fallback: Token might exist in session storage
      throw new Error(
        'No authentication token found. Close and launch application from Portal.'
      );
    } else {
      this.authStateService.login({
        accessToken: token,
        tokenType: 'Bearer',
      });
    }
  };
  protected readonly portalApiUrl = environment.portalApiUrl;
  protected readonly portalSiteUrl = environment.portalSiteUrl;
}
